import {useState} from 'react';
import {Logo, HamburgerIcon, CloseIcon} from './dark-header-common.react-component';

import {AnimatePresence, motion} from 'motion/react';

import styles from './dark-header.module.scss';
import mobileStyles from './dark-header-mobile.module.scss';

export function DarkHeaderMobile({
    navigationItems,
}: {
    navigationItems: {label: string; anchorElementId: string}[];
}) {
    const [isOpen, setIsOpen] = useState(false);

    const handleScroll = (anchorElementId: string) => {
        // Update the URL hash without triggering a page jump
        // Preserve existing query parameters and path
        const url = new URL(window.location.href);
        url.hash = anchorElementId;
        window.history.pushState({}, '', url.toString());

        const section = document.getElementById(anchorElementId);
        if (section) {
            /**
             * Setting true is the same as doing {block: "start", inline: "nearest"}
             * we do not add behavior: "smooth" because it has a weird behavior on mobile
             */
            section.scrollIntoView(true);
        }
        setIsOpen(false);
    };

    const optionsMenu = navigationItems.map((item) => (
        <motion.div
            key={item.anchorElementId}
            className={mobileStyles['menu-item']}
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            transition={{duration: 0.4}}
            onClick={() => handleScroll(item.anchorElementId)}
        >
            <span className={mobileStyles['menu-text']}>{item.label}</span>
        </motion.div>
    ));

    return (
        <div className={`${mobileStyles.navigation} ${styles.navigation}`}>
            <div className={mobileStyles['nav-content']}>
                <Logo />
                <div
                    onClick={() => setIsOpen(!isOpen)}
                    role="button"
                    tabIndex={0}
                    className={mobileStyles['menu-button']}
                >
                    {isOpen ? <CloseIcon /> : <HamburgerIcon />}
                </div>
            </div>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className={mobileStyles.menu}
                        initial={{opacity: 0, height: 0}}
                        animate={{opacity: 1, height: '100vh'}}
                        exit={{opacity: 0, height: 0}}
                        transition={{duration: 0.4}}
                    >
                        {optionsMenu}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
